<template lang='pug'>
  i.svg-icon.svg-icon-password
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
       path(d='M48.74,43.038c-2.868-7.855-10.247-13.159-18.606-13.371 c-10.437,0.078-18.836,8.599-18.761,19.037c0,0.09,0.002,0.184,0.004,0.276c-0.055,10.608,8.499,19.255,19.108,19.313 c0.006,0,0.013,0,0.02,0c8.265-0.227,15.525-5.549,18.221-13.37h19.103v11.885h12.834V54.922h7.964V43.038H48.74z M30.616,55.387 c-3.54,0-6.409-2.869-6.409-6.407s2.869-6.407,6.409-6.407c3.538,0,6.407,2.869,6.407,6.407 C37.014,52.514,34.149,55.379,30.616,55.387z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>